<template>
  <div>
    <div class="mt-14">
      <h3 class="my-8 text-3xl">
        Amazon Seller Central
      </h3>
      <paragraph
        class="my-8 flex rounded p-3"
        style="background-color: #EDEDED;"
      >
        <VueFeather
          type="info"
          class="feather-icon feather-icon-css-target"
        />
        <p>複数のセラーアカウントお持ちの場合は、事前に接続をおこないたいアカウントにログインした状態で以下リンクをクリックしてください。</p>
      </paragraph>
      <div class="text-center pt-4">
        <img
          v-if="!spApiButtonClicked"
          class="cursor-pointer"
          alt="Login with Amazon for SPApi"
          src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64.png"
          width="312"
          height="64"
          @click="onSpApiButtonClicked"
        />
        <img
          v-else-if="spApiButtonClicked"
          class="cursor-pointer"
          alt="Login with Amazon for SPApi"
          src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64_pressed.png"
          width="312"
          height="64"
          @click="onSpApiButtonClicked"
        />
      </div>
    </div>
    <vs-popup
      v-model:active="showPopup"
      :title="popupTitle"
    >
      <div
        class="text-center leading-loose"
        v-html="popupMessage"
      />
    </vs-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from '@/user/axios'
import store from '@/user/store/store'
import Paragraph from '@/components/Paragraph'

export default {
  name: 'ReOauth',
  components: {
    Paragraph
  },
  beforeRouteEnter (to, from, next) {
    next(async () => {
      try {
        await store.dispatch('account/getAccount')
      } catch (e) {
        console.error(e)
      }
    })
  },
  data () {
    return {
      spApiButtonClicked: false,
      showPopup: false,
      popupTitle: '',
      popupMessage: ''
    }
  },
  computed: {
    ...mapState('account', ['activeAccount', 'isActiveAccountNeedReauth']),
    ...mapState('auth', ['token'])
  },
  async mounted () {
    if (Object.keys(this.$route.query).length > 0) {
      const { message, success } = this.$route.query
      if (success === 'false') {
        let title = 'アカウント連携エラー'
        let m = 'エラーが発生しました。<br>カスタマーサポートまでお問い合わせください。<br>tech@ubun.co.jp'
        if (message.indexOf('the sellerId not found') >= 0) {
          title = 'このアカウントは接続することができません。'
          m = '本amazon出品者アカウントは、ubun baseに連携されていません。<br>カスタマーサポートまでお問い合わせください。<br>tech@ubun.co.jp'
        } else if (message.indexOf('the sellerId do not match') >= 0) {
          title = 'このアカウントは接続することができません。'
          m = '本amazon出品者アカウントは、ubun baseのアカウントと一致しません。<br>カスタマーサポートまでお問い合わせください。<br>tech@ubun.co.jp'
        }
        this.popupTitle = title
        this.popupMessage = m
        this.showPopup = true
      }
    }
  },
  methods: {
    onSpApiButtonClicked () {
      this.spApiButtonClicked = !this.spApiButtonClicked
      if (this.spApiButtonClicked) {
        window.location.href = `${axios.defaults.baseURL}/api/reoauth/sp/redirect?accountId=${this.activeAccount.id}&token=${this.token}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button-disabled {
  filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale"); /* Firefox 3.5+ */
  -webkit-filter: grayscale(100%); /* Chrome 19+ & Safari 6+ */
}
.mt-14 {
  margin-top: 5rem !important;
}
h2 {
  font-weight: 700 !important;
}
h3 {
  font-weight: 600 !important;
}
</style>

<style scoped>
.feather-icon-css-target :deep(.vue-feather__content) {
  width: 1.5rem !important;
  height: 1.5rem !important;
  margin-right: 0.5rem !important;
}
</style>
